module.exports = __webpack_public_path__ + "cc51b702c98798cd916ea5a3a8ca8b54.svg";